var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserTrackingFlow } from "@/types/ApplyFlowParameters";
import { ApolloClient, InMemoryCache, createHttpLink, } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
var CTK_STORAGE_KEY = "tmn-ctk";
var DO_NOT_TRACK_STORAGE_KEY = "tmn-dnt";
var DO_NOT_TRACK_DEFAULT = "1";
var FORCE_GROUPS_PARAM = "prforceGroups";
var FORCE_GROUPS_HEADER = "indeed-prforce-groups";
var CTK_HEADER = "indeed-ctk";
var DO_NOT_TRACK_HEADER = "indeed-dnt";
var PLACEMENT_ID_HEADER = "indeed-placementid";
var CTK_READY_TIMEOUT_MS = 2000;
function getForceGroupsFromUrl() {
    try {
        return new URLSearchParams(window.location.search).get(FORCE_GROUPS_PARAM);
    }
    catch (_a) {
        return null;
    }
}
function getCtkFromLocalStorage() {
    try {
        return localStorage.getItem(CTK_STORAGE_KEY);
    }
    catch (_a) {
        return null;
    }
}
function getDoNotTrackFromLocalStorage() {
    var _a;
    try {
        return ((_a = localStorage.getItem(DO_NOT_TRACK_STORAGE_KEY)) !== null && _a !== void 0 ? _a : DO_NOT_TRACK_DEFAULT);
    }
    catch (_b) {
        // Default to Do Not Track if nothing is found
        return DO_NOT_TRACK_DEFAULT;
    }
}
function getCtkReadiness(userTrackingFlow) {
    var _a, _b, _c;
    if (userTrackingFlow === UserTrackingFlow.CAREER_SITES) {
        return (_b = (_a = window.utl) === null || _a === void 0 ? void 0 : _a.whenCtkReady) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
    if (typeof tmn === "undefined")
        return undefined;
    return (_c = tmn === null || tmn === void 0 ? void 0 : tmn.whenCtkReady) === null || _c === void 0 ? void 0 : _c.call(tmn);
}
function waitForCtkReady(userTrackingFlow) {
    return __awaiter(this, void 0, void 0, function () {
        var timeoutId, ready, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    ready = getCtkReadiness(userTrackingFlow);
                    if (!ready)
                        return [2 /*return*/];
                    return [4 /*yield*/, Promise.race([
                            ready,
                            new Promise(function (resolve) {
                                timeoutId = setTimeout(resolve, CTK_READY_TIMEOUT_MS);
                            }),
                        ])];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (timeoutId !== undefined)
                        clearTimeout(timeoutId);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getClient(uri, placementId, userTrackingFlow) {
    var _this = this;
    var httpLink = createHttpLink({
        uri: uri || "/graphql",
        credentials: "include",
    });
    var ctkReadyPromise;
    var ctkLink = setContext(function (_, _a) {
        var headers = _a.headers;
        return __awaiter(_this, void 0, void 0, function () {
            var ctk, dnt, forceGroups;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        ctkReadyPromise !== null && ctkReadyPromise !== void 0 ? ctkReadyPromise : (ctkReadyPromise = waitForCtkReady(userTrackingFlow));
                        return [4 /*yield*/, ctkReadyPromise];
                    case 1:
                        _f.sent();
                        ctk = getCtkFromLocalStorage();
                        dnt = getDoNotTrackFromLocalStorage();
                        forceGroups = getForceGroupsFromUrl();
                        return [2 /*return*/, {
                                headers: __assign(__assign(__assign(__assign(__assign({}, headers), (ctk && (_b = {}, _b[CTK_HEADER] = ctk, _b))), (dnt && (_c = {}, _c[DO_NOT_TRACK_HEADER] = dnt, _c))), (placementId && (_d = {}, _d[PLACEMENT_ID_HEADER] = placementId, _d))), (forceGroups !== null && (_e = {}, _e[FORCE_GROUPS_HEADER] = forceGroups, _e))),
                            }];
                }
            });
        });
    });
    return new ApolloClient({
        link: ctkLink.concat(httpLink),
        cache: new InMemoryCache(),
    });
}
